// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/UserRoleService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { IdentityUserRoleModificationDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import type { IdentityUserDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/UserRoleService.proto.
 */
export const file_Services_UserRoleService: GenFile = /*@__PURE__*/
  fileDesc("Ch5TZXJ2aWNlcy9Vc2VyUm9sZVNlcnZpY2UucHJvdG8y3gQKD1VzZXJSb2xlU2VydmljZRKcAgoNQWRkVXNlclRvUm9sZRI9LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuYmFzaWMuSWRlbnRpdHlVc2VyUm9sZU1vZGlmaWNhdGlvbkR0bxo4LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuZGV0YWlsZWQuSWRlbnRpdHlVc2VyRGV0YWlsZWREdG8ikQGg2s0PAILT5JMChQFaIDoBKiIbL2FwaS91c2VyUm9sZS9hZGRVc2VyVG9Sb2xlGmEvYXBpL3VzZXJSb2xlL2FkZFVzZXJUb1JvbGUve3VzZXJfaWQuaGlnaF82NH0ve3VzZXJfaWQubG93XzY0fS97cm9sZV9pZC5oaWdoXzY0fS97cm9sZV9pZC5sb3dfNjR9EqsCChJSZW1vdmVVc2VyRnJvbVJvbGUSPS50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLklkZW50aXR5VXNlclJvbGVNb2RpZmljYXRpb25EdG8aOC50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmRldGFpbGVkLklkZW50aXR5VXNlckRldGFpbGVkRHRvIpsBoNrNDwCC0+STAo8BWiU6ASoiIC9hcGkvdXNlclJvbGUvcmVtb3ZlVXNlckZyb21Sb2xlKmYvYXBpL3VzZXJSb2xlL3JlbW92ZVVzZXJGcm9tUm9sZS97dXNlcl9pZC5oaWdoXzY0fS97dXNlcl9pZC5sb3dfNjR9L3tyb2xlX2lkLmhpZ2hfNjR9L3tyb2xlX2lkLmxvd182NH1CJKoCIU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5TZXJ2aWNlc2IGcHJvdG8z", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Basic, file_Messages_Detailed, file_Options_MethodOptions]);

/**
 * Operations for mapping Identity users to roles.
 *
 * @generated from service UserRoleService
 */
export const UserRoleService: GenService<{
  /**
   * Add the user with the contained id to the role with the contained id.
   *
   * @generated from rpc UserRoleService.AddUserToRole
   */
  addUserToRole: {
    methodKind: "unary";
    input: typeof IdentityUserRoleModificationDtoSchema;
    output: typeof IdentityUserDetailedDtoSchema;
  },
  /**
   * Remove the user with the contained id from the role with the contained id.
   *
   * @generated from rpc UserRoleService.RemoveUserFromRole
   */
  removeUserFromRole: {
    methodKind: "unary";
    input: typeof IdentityUserRoleModificationDtoSchema;
    output: typeof IdentityUserDetailedDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_UserRoleService, 0);

